import axios from 'axios';
import { accessToken, currentUser } from '@alli/frontend-common';

const centralApiHost = process.env.CENTRAL_API; // eslint-disable-line no-undef

export const NOT_MODIFIED = null;
export const MISSING_TOKEN = 'missing access token';

/**
 * @return Promise<object|null>
 */
export default function getUser(lastModified = null, reload = null) {
    const token = accessToken.getValue();
    if (!token) {
        return Promise.reject(MISSING_TOKEN);
    }

    const headers = {
        Authorization: token.authorizationHeader(),
        Accept: 'application/json',
    };

    if (lastModified) {
        headers['If-Modified-Since'] = lastModified;
    }

    return axios.get(`${centralApiHost}/me`, { headers }).then(
        resp => ({
            ...resp.data.user,
            lastModified: resp.headers['last-modified'] || null,
        }),
        error => {
            // with the `If-Modified-Since` header above, it's possible that
            // we get a 304 back here. Axios treats that as an error, so "handle"
            // it and ignore
            if (error.response && error.response.status === 304) {
                return NOT_MODIFIED;
            }

            // if a 401 Unauthorized response comes back our token went invalid
            // somehow -- this can happen if a user logs out or the access token
            // expires without refreshing, etc. If that's the case, we reload
            // the page to trigger and oauth flow again.
            if (error.response && error.response.status === 401) {
                (reload || document.location.reload)();
                // just to tell the caller to not do anything
                return NOT_MODIFIED;
            }

            return Promise.reject(error);
        },
    );
}
